import React, { createContext, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const PrevPathContext = createContext();

export default function PreviousLocationProvider({ children }) {
    const location = useLocation();
    const previousLocationRef = useRef(null);

    useEffect(() => {
        previousLocationRef.current = location;
    }, [location]);

    return (
        <PrevPathContext.Provider value={previousLocationRef.current}>
            {children}
        </PrevPathContext.Provider>
    );
};

export function usePreviousLocation() {
  return useContext(PrevPathContext);
}
